var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:_vm.chipColor,attrs:{"outlined":_vm.isChipOutlined}},[_c('span',{class:_vm.chipTextColor},[_vm._v(" "+_vm._s(_vm.statusLabel)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }